import { render, staticRenderFns } from "./CreateIndexGroup.vue?vue&type=template&id=755a0027&"
import script from "./CreateIndexGroup.vue?vue&type=script&lang=js&"
export * from "./CreateIndexGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports